module.exports = __webpack_public_path__ + "img/max-file-deny--csv.a94959f9.svg";